<script setup lang="ts">
import { queryURLParams, commonParams } from '@/common/utils';
import { onBeforeMount, ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { checkBridge, runBridge } from '@/common/jsBridgeUtils';
import CommonConfirm from '@/components/CommonConfirm.vue';
import arrowLeftImg from '@/assets/common/icon_back_2x.png';
import { useDriverImStore } from '@/store/driver/im/im';
import { I18nTranslate } from '@/i18n';
import settingImg from '@/assets/common/icon_settings_3x.png';
import closeImg from '@/assets/common/icon_close_nav_32_3x.png';
import { useDriverMineStore } from '@/store/driver/mine/driverMine';

defineProps<{}>();

const driverMineStore = useDriverMineStore();
const driverImStore = useDriverImStore();

const route = useRoute();
const router = useRouter();
const nameTitle = ref('dialog');
const inH5 = !checkBridge('exitLogin');

const mainPath = [
  '/driver/center',
  '/vehicle/center',
  '/vehicle/transfer',
  '/driver/empty-transfer',
  '/vehicle/empty-transfer'
];
const secondaryPath = ['/driver/mine', '/vehicle/mine'];
const imPath = ['/driver/im', '/vehicle/im'];
const rentVehicle = ['/driver/mine/rent', '/driver/mine/add-first'];
const dialogPath = ['/driver/im/dialog', '/vehicle/im/dialog'];
const tcPath = '/mine/tcconfirm';

const mainIndex = ref(-1);
const secondaryIndex = ref(-1);
const imIndex = ref(-1);
const rentIndex = ref(-1);
const tcConfirm = ref(false);

const confirmExiteShow = ref(false);

watchEffect(() => {
  const path = route.path;

  mainIndex.value = mainPath.indexOf(path);
  secondaryIndex.value = secondaryPath.indexOf(path);
  imIndex.value = imPath.indexOf(path);
  rentIndex.value = rentVehicle.indexOf(path);
  tcConfirm.value = path.includes(tcPath);
});

const backRoute = () => {
  if (secondaryIndex.value >= 0) {
    router.push({
      path: mainPath[secondaryIndex.value],
      query: commonParams()
    });
  } else if (imIndex.value >= 0) {
    router.push({
      path: mainPath[imIndex.value],
      query: commonParams()
    });
  } else if (mainIndex.value >= 0 || tcConfirm.value) {
    // 立即关闭
    if (checkBridge('closePage')) {
      confirmExiteShow.value = true;
    } else {
      console.log('no');
      tcConfirm.value &&
        router.push({
          path: route.path.replace('/mine/tcconfirm', '/empty-transfer'),
          query: commonParams()
        });
    }
  } else if (rentIndex.value >= 0) {
    const globalWindow = window as any;

    router.push({
      path:
        rentIndex.value === 0
          ? '/driver/mine'
          : globalWindow.localStorage.getItem('rentVehiclePath') || '/driver/mine',
      query: {
        ...queryURLParams(window.location.href),
        ...commonParams()
      },
      replace: true
    });
  } else if (dialogPath.includes(route.path)) {
    router.push({
      path: route.path === '/driver/im/dialog' ? '/driver/im' : '/vehicle/im',
      query: commonParams(),
      replace: true
    });
  } else {
    router.back();
  }
};

const settingRoute = () => {
  router.push({
    path: 'mine/setting',
    query: commonParams()
  });
};

const deleteAddressRoute = () => {
  driverMineStore.$patch(state => {
    state.deleteAddressFlag = true;
  });
};

watchEffect(() => {
  const index = dialogPath.indexOf(route.path);

  if (index === 0) {
    nameTitle.value = driverImStore?.driver_name || driverImStore?.receiver?.name || '';
  } else if (index === 1) {
    nameTitle.value = driverImStore?.fleet_name || driverImStore?.receiver?.name || '';
  }
});

const exitConfirm = () => {
  runBridge('closePage', {
    immediately: 0
  });
};

onBeforeMount(() => {});
</script>

<template>
  <ul class="header-nav-bar">
    <span>
      <van-icon
        v-if="!(inH5 && mainIndex >= 0)"
        :name="tcConfirm ? closeImg : arrowLeftImg"
        @click="backRoute"
      />
      <van-icon
        v-if="route.path === '/vehicle/im/invite-ob'"
        :name="closeImg"
        @click="
          () => {
            router.go(-2);
          }
        "
        style="marginleft: 0.16rem"
      />
    </span>
    <li v-if="!dialogPath.includes(route.path)" class="nav-bar-title">{{ route.meta.title }}</li>
    <li v-else class="nav-bar-title name-title">{{ nameTitle }}</li>
    <li class="nav-bar-right">
      <van-icon v-if="secondaryIndex >= 0" :name="settingImg" @click="settingRoute" />
      <span
        v-if="route.path === '/driver/mine/edit-address'"
        class="delete"
        @click="deleteAddressRoute"
      >
        {{ I18nTranslate('Fleet_Phase1_Delete_vHOi') }}
      </span>
    </li>
    <common-confirm
      :visible-show="confirmExiteShow"
      :title="I18nTranslate('Fleet_Phase3__ZyyO')"
      :confirm-text="I18nTranslate('Fleet_Phase3__LovJ')"
      :confirm-click="exitConfirm"
      :cancel-text="I18nTranslate('Fleet_Phase3__wuiT')"
      :cancel-click="() => (confirmExiteShow = false)"
      :close-click="() => (confirmExiteShow = false)"
      @shadow="value => (confirmExiteShow = value)"
    >
    </common-confirm>
  </ul>
</template>

<style lang="less">
.header-nav-bar {
  padding: 0.36rem 0.32rem;
  height: 1.12rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.32rem;
  font-family: DiDiSansPro-Bold;
  line-height: 0.38rem;
  color: #333333;
  text-align: center;
  font-weight: 700;
  background: #ffffff;
  .van-icon {
    .van-icon__image {
      font-size: 0.32rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
  .name-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 4.5rem;
  }
  .nav-bar-right {
    // line-height: 0.44rem;
    .van-icon {
      .van-icon__image {
        font-size: 0.44rem;
        width: 0.44rem;
        height: 0.44rem;
      }
    }
    .delete {
      color: #ff8040;
    }
  }
}

.brstyle {
  .header-nav-bar {
    .nav-bar-right {
      .delete {
        color: #ffaa01;
      }
    }
  }
}
</style>
